import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PermissionEnum, PermissionsAction } from '../../../user-roles/types';
import { UserPermissions } from '../../types';
import sectionActions from '../../variables';
import { usersApi } from '../services/users';

export interface UserPermissionsState {
  userPermissions?: UserPermissions;
  sectionId: PermissionEnum;
  pageId?: PermissionEnum | 'all';
  search: string;
  allActionsSectionFiltered?: PermissionsAction;
}

const initialState: UserPermissionsState = {
  sectionId: PermissionEnum.SECTION_DASHBOARD,
  pageId: undefined,
  userPermissions: undefined,
  search: '',
  allActionsSectionFiltered: {},
};

export const userPermissionsColumnSlice = createSlice({
  name: 'userPermissionsColumns',
  initialState,
  reducers: {
    onSectionChange: (state, action: PayloadAction<PermissionEnum>) => {
      state.sectionId = action.payload;
      state.allActionsSectionFiltered = action.payload
        ? sectionActions[action.payload]
        : {};
      state.search = '';
    },
    onPageChange: (
      state,
      action: PayloadAction<PermissionEnum | 'all' | undefined>,
    ) => {
      state.pageId = action.payload;
    },
    onFilterChange: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    onFilterChangeSuccess: (
      state,
      action: PayloadAction<PermissionsAction | undefined>,
    ) => {
      state.allActionsSectionFiltered = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      usersApi.endpoints.getUserPermissions.matchFulfilled,
      (state, action: PayloadAction<{ data: UserPermissions }>) => {
        state.userPermissions = action.payload.data;
      },
    );
  },
});

export const {
  onPageChange,
  onSectionChange,
  onFilterChange,
  onFilterChangeSuccess,
} = userPermissionsColumnSlice.actions;

export default userPermissionsColumnSlice.reducer;
